// src/utils/session.js
//
// Helpers de sessão. O logout faz FULL RELOAD de propósito: limpar só o
// sessionStorage e navegar via SPA deixava o AuthContext (auth.user) "grudado"
// em memória — então deslogar admin e logar usuário comum mantinha o role
// antigo e liberava telas erradas. O window.location.assign zera tudo.

export function clearSession() {
  try {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
  } catch { /* ignore */ }
}

export function logout(redirect = '/login') {
  clearSession();
  // Full reload: garante que nenhum estado de auth sobreviva em memória.
  window.location.assign(redirect);
}
